// oxlint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../webview-bridge/transport/webkit.ts" />

import { isServer } from '../env-helper';
import { ChartMessage, CloseMessage, ExternalLinkMessage, LinkMessage, ShareMessage, WebviewHandler } from './types';

/**
 * @deprecated
 * FIXME: 앱과의 통신은 [webview-bridge](../../webview-bridge/index.ts)로 통일한 다음 webview-handler 제거
 */
const webviewHandler = {
  handler() {
    if (isServer) return null;
    return window.webkit?.messageHandlers?.WebviewHandler || window.WebviewHandler;
  },
  enable() {
    return !!this.handler();
  },
  postMessage(
    msg: ChartMessage | LinkMessage | ExternalLinkMessage | CloseMessage | ShareMessage,
    failHandler?: () => unknown,
  ) {
    const handler = this.handler();
    if (handler && handler.postMessage) {
      handler.postMessage(JSON.stringify(msg));
    } else {
      failHandler?.();
    }
  },
};

export default webviewHandler;

declare global {
  interface Window {
    WebviewHandler?: WebviewHandler;
    StorageHandler?: WebviewHandler;
  }
}
